import {
  IsString,
  IsBoolean,
  IsDefined,
  IsIn,
  IsArray,
  IsNumber,
  IsOptional,
} from 'class-validator';

const INPUT_TYPE_VALUES = ['dropdown'] as const;

export class FormDropdownFieldPropsDto {
  @IsOptional()
  @IsString()
  id?: string;

  @IsDefined()
  @IsString()
  label!: string;

  @IsDefined()
  @IsBoolean()
  showLabel!: boolean;

  @IsDefined()
  @IsIn([...INPUT_TYPE_VALUES])
  inputType!: (typeof INPUT_TYPE_VALUES)[number];

  @IsDefined()
  @IsBoolean()
  required!: boolean;

  @IsDefined()
  @IsBoolean()
  hidden!: boolean;

  @IsDefined()
  @IsString()
  urlMapping!: string;

  @IsDefined()
  @IsString()
  placeholder!: string;

  @IsDefined()
  @IsArray()
  @IsString({ each: true })
  options!: string[];

  @IsDefined()
  @IsArray()
  @IsNumber({}, { each: true })
  defaultIndices!: number[];

  @IsDefined()
  @IsBoolean()
  isSingleSelect!: boolean;

  @IsDefined()
  @IsString()
  helpText!: string;

  @IsDefined()
  @IsBoolean()
  showHelpText!: boolean;
}
